import { BroadcastTabChannelType } from "@/enums/enums";
import { SocketConnect } from "@/helper/notificationHelper";
import { SetMasterTab } from "@/helper/tabHelper";

let tabChannel: BroadcastChannel | null = null;

export const SetTabChannel = () => {
  try {
    tabChannel = new BroadcastChannel("PeakAccountTab");

    tabChannel.onmessage = async (event) => {
      if (event.data) {
        switch (event.data.broadcastType) {
          case BroadcastTabChannelType.MasterTabClose:
            SetMasterTab();
            setTimeout(() => {
              SocketConnect();
            }, 0);
            break;
        }
      }
    };
  } catch {
    tabChannel = null;
    throw new Error("Your browser doesn't support BroadcastChannel");
  }
};

export const BroadcastTabChannelMasterTabClose = () => {
  if (tabChannel) {
    tabChannel.postMessage({
      broadcastType: BroadcastTabChannelType.MasterTabClose,
      request: null,
    });
  }
};

export const CheckBroadcastIsSupport = () => {
  return tabChannel !== null;
};
